import React, {Component} from 'react'
import MultiSelect from '../../../MultiSelect'
import {FieldGroup, Field, Select, InputText, Icon, TemplateVariable} from 'bsui'
import SettingsGroup from '../../../struct/SettingsGroup'
import {observer} from 'mobx-react'
import Hint from '../../../struct/Hint'

import styles from './StatusesSettings.less'

const fields_dbs = [
    {
        title: 'Заказ создан',
        name: 'order_action_accept'
    },
    {
        title: 'Ожидается оплата',
        name: 'order_action_unpaid'
    },
    {
        title: 'Можно обрабатывать, предоплата',
        name: 'order_action_processing_prepaid'
    },
    {
        title: 'Можно обрабатывать, оплата по факту',
        name: 'order_action_processing_postpaid'
    },
    {
        title: 'Заказ отменён до отправки',
        name: 'order_action_cancelled_before'
    },{
        title: 'Заказ отменён после отправки',
        name: 'order_action_cancelled_after'
    },
    {
        title: 'Покупатель запросил отмену',
        name: 'order_action_cancel_notification'
    },
    {
        title: 'Доставляется',
        name: 'order_action_delivery'
    },
    {
        title: 'Доставлен',
        name: 'order_action_delivered'
    }
]

const fields_fbs = [
    {
        title: 'Заказ создан',
        name: 'order_action_accept'
    },
    {
        title: 'Ожидается оплата',
        name: 'order_action_unpaid'
    },
    {
        title: 'Можно обрабатывать, предоплата',
        name: 'order_action_processing_prepaid'
    },
    {
        title: 'Можно обрабатывать, оплата по факту',
        name: 'order_action_processing_postpaid'
    },
    {
        title: 'Заказ передан в службу доставки',
        name: 'order_action_delivery'
    },
    {
        title: 'Заказ доставлен в пункт самовывоза',
        name: 'order_action_pickup'
    },
    {
        title: 'Заказ доставлен покупателю',
        name: 'order_action_delivered'
    },
    {
        title: 'Заказ отменён до отправки',
        name: 'order_action_cancelled_before'
    },{
        title: 'Заказ отменён после отправки',
        name: 'order_action_cancelled_after'
    },
]

const fbs_actions = [
    'accept',
    'unpaid',
    'processing_prepaid',
    'processing_postpaid',
    'cancelled_before',
    'cancelled_after',
    'delivered',
    'delivery',
    'pickup',
]

export default class IncomeStatusesSettings extends Component {
    constructor(props) {
        super(props)
        const fields = this.updateCampaignStatuses()
        this.state = {
            fields: fields
        }
        this.statuses = props.statuses
        this.onMultiSelectChangeWrapper = this.onMultiSelectChangeWrapper.bind(this)
    }

    updateCampaignStatuses(){
        let fields = {}
        if (this.props.type === 'DBS') {
           fields_dbs.map(field => {
               this.props.campaign[field.name] = this.props.campaign[field.name] ? this.props.campaign[field.name] :
                   this.props.settings[field.name] ? this.props.settings[field.name] : []
               if(this.props.settings[field.name]) this.props.settings[field.name] = ""
               fields[field.name] = {
                   values:this.props.campaign[field.name]
               }
           })
        } else {
            const suffix = this.props.type.toLowerCase()
            fbs_actions.map( action => {
                let field = 'order_action_' + action
                let field_settings = 'order_action_' + suffix + '_' +action
                this.props.campaign[field] = this.props.campaign[field] ? this.props.campaign[field] :
                    this.props.settings[field_settings] ? this.props.settings[field_settings] : []
                if(this.props.settings[field_settings]) this.props.settings[field_settings] = ""
                fields[field] = {
                    values: this.props.campaign[field]
                }
            })
        }
        return fields
    }

    onMultiSelectChangeWrapper(e) {
        const {name, value} = e.target
        const currentFields = this.state.fields
        this.setState({
            fields: {
                ...currentFields,
                [name]: {
                    values: value.values
                }
            }
        })

        this.props.campaign[name] = value.values
    }

    updateFields(){
        const fields = this.updateCampaignStatuses()
        this.setState({
            fields: fields
        })
    }

    componentWillMount = () => {
        this.updateFields();
    }

    componentWillReceiveProps = () => {
        this.updateFields();
    }

    render() {
        const {type} = this.props
        const fields = type === 'DBS' ? fields_dbs : fields_fbs
        const title = type === 'DBS' ? '8. Сопоставление действий с заказами при запросах из Я.Маркет' : '7. Сопоставление действий с заказами при запросах из Я.Маркет'

        return (
            <div>
	            <SettingsGroup title={title}>
                    <Hint  className={styles['hintHeader']}>{'Если в Яндекс.Маркете статус заказа сменился, в вашем магазине с этим заказом будет выполнено выбранное здесь действие. Заполнять все поля необязательно. '}</Hint>
		            <table className="zebra">
			            <thead>
			            <tr>
				            <th>
                                Событие в Я.Маркете:
				            </th>
				            <th>
                                Действие в вашем магазине:
				            </th>
			            </tr>
			            </thead>
			            <tbody>
			            {fields.map(field => {
				            const {title, name, hint} = field
				            const fieldState = this.state.fields[name]
				            let label = title

				            if (hint) {
					            label = (
						            <React.Fragment>
							            {title}
							            <span className={'shop-tooltip' + ' ' + styles['tooltip-wrapper']}>
								            <i className="icon10 info"></i>
								            <span>
									            {hint}
								            </span>
							            </span>
						            </React.Fragment>
					            )
				            }

				            if (fieldState !== undefined) {
					            return (
						            <tr key={name}>
							            <td className={styles['status-label']}>
								            {label}
							            </td>
							            <td className={styles['status-values']}>
								            <MultiSelect
									            name={name}
									            options={this.statuses}
									            value={fieldState}
									            optionRenderer={(data) => (
										            <div
											            key={data.key}
											            className={"VirtualizedSelectOption" + (data.optionIndex === data.focusedOptionIndex
												            ? " VirtualizedSelectFocusedOption" : "")}
											            style={data.style}
											            onMouseOver={e => data.focusOption(data.option)}
											            onClick={e => data.selectValue(data.option)}>
											            {data.option.label}
										            </div>
									            )}
									            valueRenderer={data => data.label}
									            onChange={this.onMultiSelectChangeWrapper}
								            />
							            </td>
						            </tr>)
				            }
			            })}
			            </tbody>
		            </table>
	            </SettingsGroup>
            </div>
        )
    }
}